













































































































































































































































































































































































































































































import { objectIsEmpty } from '@/utils';
import {Vue, Component, Prop} from 'vue-property-decorator';
import {NavigationPanel} from '@/components/NavigationPanel';
import PeriodPickerContainer from '@/components/PeriodPickerContainer';
import PeriodPicker from '@/components/PeriodPicker';
import ChangePriceBlock from '@/components/ChangePriceBlock';
import {mapGetters, mapActions} from 'vuex';
import VLazyImage from 'v-lazy-image';
import {toTop} from '@/utils';
import DateMixins from '@/core/dateMixins';

@Component({
  name: 'ProfileApartmentOneCreate',
  components: {
    NavigationPanel, PeriodPicker,
    PeriodPickerContainer, VLazyImage,
    ChangePriceBlock,
  },
  mixins: [DateMixins],
  props: {
    apartment: {
      type: Object,
      default: () => {
      },
    },
    apartmentTexts: {
      type: Object,
      default: () => {
      },
    },
    leavePopup: {
      type: Boolean,
      default: false,
    },
    linkToRout: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      inputTitle: this.apartment.rent_ad_request ? this.apartment.rent_ad_request.title : '',
      inputDeck: this.apartment.rent_ad_request ? this.apartment.rent_ad_request.description : '',
      activeOptions: this.apartment.options && this.apartment.options.length > 0 ? this.activeApartmentOptions() : [],
      activeRules: [this.apartment.rule_pets_allowed ? 'rule_pets_allowed' : '',
                    this.apartment.rule_parties_allowed ? 'rule_parties_allowed' : '',
                    this.apartment.rule_smoking_allowed ? 'rule_smoking_allowed' : ''],
      coverImage: this.apartment.apartment_photos ? this.apartment.apartment_photos : [],
      endDate: null,
      startDate: null,
      showDatePicker: false,
      recommendedPrice: this.apartment.recommended_price,
      userPrice: this.apartment.recommended_price,
      servicePrice: 0,
      showHelpPopup: false,
      showThanksPopup: false,
      showInfoBlock: false,
      errorTitle: false,
      errorDeck: false,
      showErrorFirst: false,
      showErrorSecond: false,
      errorPrice: false,
      monthCount: 7,
      backendError: '',
    };
  },
  created() {
    document.addEventListener('click', this.clickOnPage);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickOnPage);
  },
  computed: {
    ...mapGetters(['language', 'filters', 'searchingPanelState', 'percentForServices', 'translations']),
    ...mapGetters('profile', ['stepNumber', 'createAdTexts']),

    startDateComputed: {
      get() { return this.startDate || (this as any).minDate; },
      set(value) { this.startDate = value; },
    },

    inputTitleLength() {
      return 50 - (this as any).inputTitle.length;
    },

    inputDeckLength() {
      return 500 - (this as any).inputDeck.length;
    },

    showCancelPopup: {
      get() {
        return this.leavePopup;
      },
      set(val) {
        return val;
      },
    },

    optionsList() {
      if ((this as any).createAdTexts) {
        let list = [];
        for (const category of (this as any).createAdTexts.first_step.apartment_options_block.categories) {
          list = list.concat(category.items);
        }
        return list;
      }
    },

    minDate() {
      return this.apartment.lease_contract
          ? this.apartment.lease_contract.end
          : new Date().toISOString().substring(0, 10);
    },
  },
  methods: {
    ...mapActions('profile', ['addStepNumber', 'clearStepNumber', 'sendAdRequest']),
    nextStep() {
      if (this.stepNumber === 1 && this.inputTitle.length !== 0 && this.inputDeck.length !== 0) {
        this.showErrorFirst = false;
        this.addStepNumber();
        toTop();
      } else if (this.stepNumber === 1) {
        this.errorTitle = this.inputTitle.length === 0;
        this.errorDeck = this.inputDeck.length === 0;
        this.showErrorFirst = true;
      } else if (this.stepNumber === 2 && this.coverImage.length !== 0) {
        this.showErrorSecond = false;
        this.addStepNumber();
        toTop();
      } else if (this.stepNumber === 2) {
        this.showErrorSecond = true;
      }
    },

    closeCreatePage() {
      this.inputTitle = '';
      this.inputDeck = '';
      this.coverImage = [];
      (this as any).userPrice = null;
      this.$emit('readyRoute');
      this.$emit('closePopup');
      this.clearStepNumber();
      this.linkToRout ? this.$router.push(this.linkToRout) : (() => false)();
    },

    pickFile() {
      (this as any).$refs.uploadFile.click();
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.coverImage.push({filename: files[0].name, content: fr.result});
        });
      } else {
        console.error('error on upload photo');
      }
    },

    changeCover(id) {
      this.coverImage = this.coverImage.splice(id, 1).concat(this.coverImage);
    },

    deleteImg(id) {
      this.coverImage.splice(id, 1);
    },

    clickOnPage(e) {
      if (this.showDatePicker
          && e.target.id !== 'date-block'
          && e.target.parentElement.id !== 'date-block'
          && (this as any).$refs.datePickerBlock
          && !(this as any).$refs.datePickerBlock.$el.contains(e.target)) {
        this.showDatePicker = !this.showDatePicker;
      }
    },

    sendNewAd() {
      if (this.userPrice) {
        const apartmentId = this.$route.params.id;
        const dataAd = {
          title: this.inputTitle,
          description: this.inputDeck,
          price: this.userPrice ? this.userPrice : this.recommendedPrice,
          start: (this as any).startDateComputed,
          end: this.endDate,
          apartment: apartmentId,
        };
        const dataApartment = {
          upload_photos: this.coverImage,
          options: this.activeOptions,
          rule_parties_allowed: this.activeRules.includes('rule_parties_allowed'),
          rule_pets_allowed: this.activeRules.includes('rule_pets_allowed'),
          rule_smoking_allowed: this.activeRules.includes('rule_smoking_allowed'),
        };
        const update = this.apartment.rent_ad_request !== null && !objectIsEmpty(this.apartment.rent_ad_request)
            ? this.apartment.rent_ad_request.id
            : false;
        (this as any).sendAdRequest({dataAd, dataApartment, apartmentId, update})
            .then((response) => {
              if (response.status === 400) {
                (this as any).backendError = response.data?.mobile_errors[0]?.messages[0];
                this.errorPrice = true;
              } else {
                this.showThanksPopup = true;
              }
            })
            .catch((error) => console.error(error));
      } else {
        this.errorPrice = true;
      }
    },

    closePopup() {
      this.$emit('notReady');
      this.$emit('closePopup');
    },

    closeThanksPopup() {
      this.showThanksPopup = false;
      this.closeCreatePage();
      this.$emit('notReady');
    },

    changeVariableAtString(str, count) {
      return str.replace('%(count)s', count);
    },

    activeApartmentOptions() {
      const activeOption: string[] = [];
      for (const option of this.apartment.options) {
        if (option.id) {
          activeOption.push(option.id);
        }
      }
      return activeOption;
    },

    srcImg(photo) {
      return photo && `${photo[3600]}` || '';
    },

    srcImgPlaceholder(photo) {
      return photo && `${photo[400]}`;
    },

    srcSet(photo) {
      return photo && `${photo[400]} 400w, ${photo[400]} 800w,
      ${photo[400]} 1300w, ${photo[800]} 1900w, ${photo[3600]} 3600w`;
    },

    changeUserPrice(value) {
      this.userPrice = value;
      this.errorPrice = false;
    },
  },
})
export default class ProfileApartmentOneCreate extends Vue {
}
